import { useToastContext } from '../contexts/ToastContext';

export type { ToastType, ToastItem } from '../contexts/ToastContext';

export function useToast() {
  const { showToast } = useToastContext();
  return { showToast };
}
